import React from 'react'
import PropTypes from 'prop-types'

import Select from '../Select'

const PseudoSelect = ({ isOpen, ...props }) => {
  // component recreates UI of Select component but not functional it self
  return (
    <Select
      pseudoOpened={isOpen}
      formatValue={false}
      isSearchable={false}
      options={[]}
      pseudoDisabled
      usePortal
      {...props}
    />
  )
}

PseudoSelect.propTypes = {
  // isOpen used for representing UI layer of Select(like dropdownIndicator position)
  isOpen: PropTypes.bool
}

export default PseudoSelect
